module.exports = __webpack_public_path__ + "img/icon-letter-z.4de7083a.svg";